import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addChildItem: {
		id: 'business-list.list-view.type-cell.add-child-item',
		defaultMessage: 'Add child item',
		description: 'A button to create child item/issue',
	},
	createSubtask: {
		id: 'business-list.list-view.type-cell.create-subtask',
		defaultMessage: 'Create subtask',
		description: 'Tooltip text to create subtask',
	},
	createTask: {
		id: 'business-list.list-view.type-cell.create-task',
		defaultMessage: 'Create',
		description: 'Tooltip text to create child under an epic',
	},
	createChildItem: {
		id: 'business-list.list-view.type-cell.create-child-item',
		defaultMessage: 'Create child issue',
		description: 'Text for the button to create child item/issue',
	},
	createChildItemIssueTermRefresh: {
		id: 'business-list.list-view.type-cell.create-child-item-issue-term-refresh',
		defaultMessage: 'Create child work item',
		description: 'Text for the button to create child item/issue',
	},
	createChildItemIssueTerminologyRefreshM4: {
		id: 'business-list.list-view.type-cell.create-child-item-issue-terminology-refresh-m4',
		defaultMessage: 'Create {issueLevel, select, subtask {subtask} other {child work item}}',
		description: 'Text for the button to create child item/issue',
	},
});
